import { render, staticRenderFns } from "./NewApplicant.vue?vue&type=template&id=5d1a298e"
import script from "./NewApplicant.vue?vue&type=script&lang=js"
export * from "./NewApplicant.vue?vue&type=script&lang=js"
import style0 from "./NewApplicant.vue?vue&type=style&index=0&id=5d1a298e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1a298e')) {
      api.createRecord('5d1a298e', component.options)
    } else {
      api.reload('5d1a298e', component.options)
    }
    module.hot.accept("./NewApplicant.vue?vue&type=template&id=5d1a298e", function () {
      api.rerender('5d1a298e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/NewApplicant.vue"
export default component.exports